import { useRef } from 'react';
import GooglePreview, { GooglePreviewRef } from './GooglePreview';
import Box from '@mui/material/Box';
import ButtonGroup from '@mui/material/ButtonGroup';
import CommonButton from '@/shared/components/CommonButton';
import { useAppSelector } from '@/store/hooks/redux';
import { selectSingleCreativeMedia } from '@/editor/store/selectors/creative.selectors';
import { AvailablePlatformsEnum } from '@/editor/shared/constants/available-platforms';
import { useGoogleCropperLogic } from './useGoogleCropperLogic';

export const GooglePreviewContainer = () => {
  const googlePreviewRef = useRef<GooglePreviewRef>(null);
  const creativeMedia = useAppSelector((state) => selectSingleCreativeMedia(state, AvailablePlatformsEnum.GOOGLE_ADS));
  const { currentRatio, handleAspectRatioClick, handleCropChange } = useGoogleCropperLogic(
    googlePreviewRef,
    creativeMedia
  );

  return (
    <Box sx={{ width: '100%' }}>
      <GooglePreview ref={googlePreviewRef} image={creativeMedia} onCropChange={handleCropChange} />
      <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
        <ButtonGroup>
          <CommonButton className={currentRatio === 1 ? 'btn-selected' : ''} onClick={() => handleAspectRatioClick(1)}>
            1:1
          </CommonButton>
          <CommonButton
            className={currentRatio === 1.91 ? 'btn-selected' : ''}
            onClick={() => handleAspectRatioClick(1.91)}>
            1.91:1
          </CommonButton>
        </ButtonGroup>
      </Box>
    </Box>
  );
};
